interface TextDetailContainerType {
  children: React.ReactNode;
  className?: string;
}

const TextDetailContainer = ({
  children,
  className = "",
}: TextDetailContainerType) => {
  return (
    <div
      className={`w-full p-5 rounded-[10px] flex flex-col gap-5 bg-ashbg ${className}`}>
      {children}
    </div>
  );
};

export default TextDetailContainer;
